export const types = {
	INIT_DOCUMENTS: "INIT_FORM26_DOCUMENTS",
	ADD_DOCUMENT: "ADD_FORM26_DOCUMENT",
	REMOVE_DOCUMENT: "REMOVE_FORM26_DOCUMENT",
	RESET_DOCUMENTS: "RESET_FORM26_DOCUMENTS",
}

export const initForm26Docs = (documents) => {
	return (dispatch) => dispatch({
		type: types.INIT_DOCUMENTS,
		payload: documents
	})
}

export const addForm26Doc = (docData) => {
	return (dispatch) => dispatch({
		type: types.ADD_DOCUMENT,
		payload: docData
	})
}

export const removeForm26Doc = (docId) => {
	return (dispatch) => dispatch({
		type: types.REMOVE_DOCUMENT,
		payload: docId
	})
}

export const resetForm26Docs = () => {
	return (dispatch) => dispatch({
		type: types.RESET_DOCUMENTS,
	})
}
